import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomCartState, StateWithCustomCart } from '../cart-state';
import { getCustomCartState } from './feature.selector';

export const getVoucherError: MemoizedSelector<StateWithCustomCart, string | null> = createSelector(
  getCustomCartState,
  (state: CustomCartState) => state.voucherError,
);
